{
  "64.0": "Angola",
  "45.0": "Argentina",
  "16.0": "Belgium",
  "119.0": "Burkina Faso",
  "140.0": "Bahamas",
  "23.0": "Brazil",
  "176.0": "Barbados",
  "10.0": "Canada",
  "15.0": "Switzerland",
  "41.0": "Chile",
  "1.0": "China",
  "56.0": "Colombia",
  "80.0": "Costa Rica",
  "3.0": "Germany",
  "37.0": "Denmark",
  "87.0": "Dominican Republic",
  "65.0": "Ecuador",
  "17.0": "Spain",
  "8.0": "France",
  "11.0": "United Kingdom",
  "55.0": "Greece",
  "101.0": "Guyana",
  "32.0": "Hong Kong",
  "98.0": "Honduras",
  "27.0": "Indonesia",
  "14.0": "India",
  "69.0": "Iran",
  "6.0": "Italy",
  "157.0": "Jamaica",
  "5.0": "South Korea",
  "128.0": "Lebanon",
  "86.0": "Sri Lanka",
  "9.0": "Mexico",
  "163.0": "Montenegro",
  "20.0": "Malaysia",
  "141.0": "New Caledonia",
  "53.0": "Nigeria",
  "7.0": "Netherlands",
  "59.0": "New Zealand",
  "66.0": "Pakistan",
  "111.0": "Panama",
  "49.0": "Peru",
  "43.0": "Philippines",
  "92.0": "Paraguay",
  "151.0": "Palestine",
  "39.0": "Qatar",
  "40.0": "Romania",
  "26.0": "Saudi Arabia",
  "124.0": "Sudan",
  "110.0": "El Salvador",
  "138.0": "Suriname",
  "54.0": "Slovenia",
  "33.0": "Sweden",
  "167.0": "Seychelles",
  "161.0": "Syria",
  "25.0": "Thailand",
  "97.0": "Trinidad and Tobago",
  "12.0": "Taiwan",
  "2.0": "United States",
  "116.0": "Venezuela",
  "149.0": "Yemen",
  "36.0": "South Africa",
  "24.0": "United Arab Emirates",
  "118.0": "Armenia",
  "22.0": "Australia",
  "31.0": "Austria",
  "71.0": "Azerbaijan",
  "150.0": "Benin",
  "57.0": "Bangladesh",
  "58.0": "Bulgaria",
  "83.0": "Bahrain",
  "100.0": "Bosnia and Herzegovina",
  "75.0": "Belarus",
  "95.0": "Bolivia",
  "91.0": "Brunei",
  "82.0": "Côte d’Ivoire",
  "30.0": "Czechia",
  "62.0": "Algeria",
  "60.0": "Egypt",
  "133.0": "Ethiopia",
  "44.0": "Finland",
  "102.0": "Gabon",
  "122.0": "Georgia",
  "84.0": "Guatemala",
  "72.0": "Croatia",
  "35.0": "Hungary",
  "29.0": "Ireland",
  "42.0": "Iraq",
  "48.0": "Israel",
  "90.0": "Jordan",
  "4.0": "Japan",
  "47.0": "Kazakhstan",
  "106.0": "Kenya",
  "136.0": "Kyrgyzstan",
  "50.0": "Kuwait",
  "61.0": "Lithuania",
  "79.0": "Luxembourg",
  "77.0": "Latvia",
  "63.0": "Morocco",
  "99.0": "North Macedonia",
  "112.0": "Mali",
  "127.0": "Malta",
  "73.0": "Myanmar",
  "108.0": "Mozambique",
  "143.0": "Mauritius",
  "166.0": "Malawi",
  "34.0": "Norway",
  "155.0": "Nepal",
  "21.0": "Poland",
  "46.0": "Portugal",
  "13.0": "Russia",
  "117.0": "Senegal",
  "18.0": "Singapore",
  "67.0": "Serbia",
  "38.0": "Slovakia",
  "145.0": "Tajikistan",
  "93.0": "Turkmenistan",
  "78.0": "Tunisia",
  "28.0": "Turkey",
  "52.0": "Ukraine",
  "96.0": "Uruguay",
  "81.0": "Uzbekistan",
  "123.0": "Zimbabwe",
  "114.0": "Botswana",
  "104.0": "Republic of the Congo",
  "196.0": "Cabo Verde",
  "126.0": "Cyprus",
  "85.0": "Ghana",
  "134.0": "Madagascar",
  "130.0": "Mauritania",
  "121.0": "Namibia",
  "132.0": "Togo",
  "105.0": "Tanzania",
  "125.0": "Uganda",
  "19.0": "Vietnam",
  "109.0": "Zambia",
  "186.0": "Antigua and Barbuda",
  "164.0": "Fiji",
  "103.0": "Laos",
  "191.0": "Saint Vincent and the Grenadines",
  "148.0": "Afghanistan",
  "193.0": "Andorra",
  "188.0": "Burundi",
  "174.0": "Belize",
  "184.0": "Bermuda",
  "115.0": "Cameroon",
  "142.0": "Cayman Islands",
  "74.0": "Estonia",
  "165.0": "Gambia",
  "156.0": "Greenland",
  "113.0": "Iceland",
  "70.0": "Cambodia",
  "147.0": "Liberia",
  "68.0": "Libya",
  "146.0": "Macao",
  "131.0": "Moldova",
  "158.0": "Marshall Islands",
  "139.0": "Niger",
  "107.0": "Nicaragua",
  "51.0": "Oman",
  "185.0": "French Polynesia",
  "154.0": "Rwanda",
  "162.0": "Sierra Leone",
  "137.0": "Eswatini",
  "195.0": "Aruba",
  "129.0": "Albania",
  "169.0": "Eritrea",
  "181.0": "Gibraltar",
  "120.0": "Equatorial Guinea",
  "182.0": "Vanuatu",
  "177.0": "Bhutan",
  "192.0": "Central African Republic",
  "152.0": "Djibouti",
  "189.0": "Micronesia",
  "160.0": "Lesotho",
  "172.0": "Maldives",
  "168.0": "Somalia",
  "135.0": "Chad",
  "76.0": "Democratic Republic of the Congo",
  "144.0": "Cuba",
  "89.0": "Guinea",
  "190.0": "Guinea-Bissau",
  "159.0": "Haiti",
  "94.0": "Mongolia",
  "88.0": "Papua New Guinea",
  "171.0": "Solomon Islands",
  "183.0": "San Marino",
  "173.0": "British Virgin Islands",
  "175.0": "Falkland Islands",
  "198.0": "Kiribati",
  "187.0": "Nauru",
  "180.0": "Timor-Leste",
  "153.0": "Faroe Islands",
  "179.0": "North Korea",
  "194.0": "Tokelau"
}
